import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const Item: any = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 28px;
  width: 28px;
  border-radius: 14px;
  border-width: 1px;
  border-style: solid;
  background-color: ${(props: any) => (props?.isSelected ? "#02DE7F" : "#fff")};
  border-color: ${(props: any) => (props?.isSelected ? "#02DE7F" : "#666666")};
  align-items: center;
  justify-content: center;
  cursor: ${(props: any) => (props?.disabled ? "not-allowed" : "pointer")};
  opacity: ${(props: any) => (props?.disabled ? 0.6 : 1)};
  pointer-events: ${(props: any) => (props?.disabled ? "none" : "auto")};
`;

export const ItemText: any = styled.p`
  color: ${(props: any) => (props?.isSelected ? "#fff" : "#666666")};
`;
